module.exports = __webpack_public_path__ + "static/media/management.9115e4d5.png";